<p class="attention text-b3-m-500 text-lg-b3-m-700">в выбранном вами населённом пункте отсутствует магазин.</p>

<div class="delivery-info text-b3-m-300">
  Возможность доставки можно уточнить по телефону
  <sd-phone class="phone text-b3-m-300 link-black link-hover-underlined link-hover-orange"></sd-phone>
</div>
